<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2">mdi-truck-delivery-outline</v-icon>
      Quotes by Delivery Type
    </v-card-title>
    <v-card-text>
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else-if="!deliveries.length" class="text-center py-8 text-grey">
        No data available
      </div>
      <v-table v-else>
        <thead>
          <tr>
            <th>Delivery Type</th>
            <th class="text-right">Quotes</th>
            <th class="text-right">%</th>
            <th style="width: 140px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in deliveries" :key="item.deliveryType">
            <td class="font-weight-medium">{{ item.deliveryType }}</td>
            <td class="text-right font-weight-bold">{{ item.count }}</td>
            <td class="text-right text-medium-emphasis">{{ item.percentage }}%</td>
            <td>
              <v-progress-linear
                :model-value="Number(item.percentage)"
                color="info"
                height="6"
                rounded
              ></v-progress-linear>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="font-weight-bold">Total</td>
            <td class="text-right font-weight-bold">{{ total }}</td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
      </v-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { statisticsService } from '../services';

export default {
  name: 'DeliveryBreakdownTable',
  props: {
    startDate: { type: [String, Date], required: true },
    endDate: { type: [String, Date], required: true },
  },
  data() {
    return {
      loading: false,
      deliveries: [],
      total: 0,
    };
  },
  watch: {
    startDate: { immediate: true, handler() { this.loadData(); } },
    endDate: { handler() { this.loadData(); } },
  },
  methods: {
    toYmd(d) {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const day = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    async loadData() {
      this.loading = true;
      try {
        const response = await statisticsService.getQuotesByDelivery({
          startIso: this.toYmd(this.startDate),
          endIso: this.toYmd(this.endDate),
        });
        if (response?.success) {
          this.deliveries = response.data.deliveries;
          this.total = response.data.total;
        } else {
          this.deliveries = [];
          this.total = 0;
        }
      } catch (e) {
        console.error('Failed to load delivery breakdown', e);
        this.deliveries = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
